import React from 'react';
import ReactJson from '@microlink/react-json-view';
import './JsonPanel.css';

/**
 * A JSON document, read-only, in a frame.
 *
 * This is the viewer from the service item's Declarations tab — the one the
 * rest of the app shows a declaration in — said once instead of being restated
 * with slightly different props everywhere a document turns up. The frame is
 * the panel's; the viewer inside it draws no border of its own.
 */
const JsonPanel = ({
    data,
    /** extra classes on the frame, for a page that already styles this box */
    className,
    /** collapse below this depth — leave off to open the whole document */
    collapsed,
    /** the root name; off by default, since the frame already says what this is */
    name = false,
}: {
    data: any;
    className?: string;
    collapsed?: boolean | number;
    name?: string | false;
}) => (
    <div className={`njp${className ? ` ${className}` : ''}`}>
        <ReactJson
            style={{ padding: '16px', background: 'transparent' }}
            src={data}
            name={name}
            collapsed={collapsed}
            displayDataTypes={false}
            displayArrayKey={false}
            displayObjectSize={false}
        />
    </div>
);

export default JsonPanel;
